var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeorrefIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12 5a5.5 5.5 0 0 0-5.5 5.5c0 3.75 3.75 8.5 5.05 9.95.23.25.67.25.9 0 1.3-1.45 5.05-6.2 5.05-9.95A5.5 5.5 0 0 0 12 5m0 7.5A2.25 2.25 0 1 1 12 8a2.25 2.25 0 0 1 0 4.5",
  clipRule: "evenodd"
})));
export default SvgGeorrefIcon;